<div class="loading-container">
  <div class="loading-content">
    <div class="loading-logo">
      <app-company-logo></app-company-logo>
    </div>

    <div *ngIf="spinner" class="loading-spinner">
      <span class="loader"></span>
    </div>

    <div *ngIf="progressBar" class="loading-progressBar">
      <p id="loadingProgressLabel" class="loading-text">
        {{ currentMessage }}
      </p>

      <mat-progress-bar mode="determinate" [value]="value" aria-labelledby="loadingProgressLabel"> </mat-progress-bar>
    </div>
  </div>
</div>
